import { Button, Form, Modal, notification, Upload } from "antd";
import { RcFile } from "antd/lib/upload";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Dispatch } from "redux";
import { addImage } from "../../../../../Actions/RetailMatchActions";
import { beforeUploadFileCheck } from "../../../../../Logic/FileLogic";
import { IRetailMatchJob } from "../../../../../Models/IRetailMatch";
import { IAddRetailMatchImageRequest } from "../../../../../Models/Requests/IAddRetailMatchImageRequest";
import { BodyText } from "../../../../Common/ReportStyles/Text";

interface IRetailMatchIntroAddPhotoProps {
  job: IRetailMatchJob;
  visible: boolean;
  setVisible: (show: boolean) => void;
}

const RetailMatchIntroAddPhoto = (props: IRetailMatchIntroAddPhotoProps) => {
    const dispatch: Dispatch<any> = useDispatch();
    const { setVisible, job, visible } = props;

    const [photoUploadList, setPhotoUploadList] = useState<any>([]);
    const [photosReadyForUpload, setPhotosReadyForUpload]
    = useState<boolean>(false);
    const [loadingUpdateJob, setLoadingUpdateJob] = useState<boolean>();

    const submitAddImageRequest = (): void => {
        setLoadingUpdateJob(true);
        const uploadPhoto: IAddRetailMatchImageRequest = {
            jobId: job.jobId,
            image: photoUploadList[0],
        };

        dispatch(
            addImage(uploadPhoto, () => {
                setLoadingUpdateJob(false);
                setVisible(false);
                setPhotoUploadList([]);
                setPhotosReadyForUpload(false);
            })
        );
    };

    const handleRemovePhoto = (file: RcFile): void => {
    //THE COMMENTED CODE HANDLES BULK UPLOADS

        // let currentList: RcFile[] = [...photoUploadList];
        // let fileIndex: number = currentList.indexOf(file);

        // currentList.splice(fileIndex, 1);

        // if (currentList.length < 1) {
        //     setPhotosReadyForUpload(false);
        // }

        // setPhotoUploadList(currentList);
        setPhotosReadyForUpload(false);
        setPhotoUploadList([]);
    };

    const handleBeforeUpload = (file: RcFile): boolean => {
    // let currentList: RcFile[] = [...photoUploadList, file];

        if (beforeUploadFileCheck(file)) {
            setPhotoUploadList([file]);
            setPhotosReadyForUpload(true);

            return false;
        }

        return true;
    };

    return (
        <Modal
            title="Add Site Photos"
            visible={visible}
            centered={true}
            onCancel={() => setVisible(false)}
            footer={false}
        >
            <Form.Item label="Upload">
                <Upload
                    name="logo"
                    listType="picture"
                    multiple={false}
                    fileList={photoUploadList}
                    beforeUpload={(file: RcFile) => handleBeforeUpload(file)}
                    onRemove={(file: RcFile) => handleRemovePhoto(file)}
                >
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={loadingUpdateJob}
                        disabled={photosReadyForUpload}
                    >
            Select a photo to upload.
                    </Button>
                </Upload>
                {photosReadyForUpload ? (
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={loadingUpdateJob}
                        onClick={submitAddImageRequest}
                    >
            Click to upload
                    </Button>
                ) : null}
                <BodyText>Accepted file types: .jpg, .jpeg, .png.</BodyText>
            </Form.Item>
        </Modal>
    );
};

export default RetailMatchIntroAddPhoto;
